
import GroupTitle from 'vux/src/components/group-title/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'

import $ from 'jquery';
import Uploader from 'vux-uploader-component'
import lrz from "lrz"

import tabbar from '@/components/tabbar'
export default{
components: {
GroupTitle,
Group,
tabbar,
XButton,
Cell,
Confirm,
XHeader,
Selector,
XInput,
CellBox,
XTextarea,
Uploader,
},
data(){
return{
claList: [
{key: '20190920-10', value: '杂损控除'},
{key: '20190920-11', value: '医疗控除'},
{key: '20190920-13', value: '小规模企业共济等挂金控除'},
{key: '20190920-12', value: '社会保险料控除'},
{key: '20190920-15', value: '地震保险料控除'},
{key: '20190920-16', value: '寄附金控除'},
{key: '20190920-18', value: '寡妇/寡夫控除'},
{key: '20190920-1920', value: '勤劳学生、障害者控除'},
{key: '20190920-2122', value: '配偶者(特别)控除'},
{key: '20190920-23', value: '扶养控除'},
],
defaultValue:"",
detailCla:"",
money:"",
des:"",
fileList: [],
file:"",
headers:{},
taxExtraList:[{
amount:"",
category:"",
desc:"",
imageLink:""
}
],
taxId:"",
taxFee:"",
per:"",
pres:"",
}
},
created(){
let authKey;
let loginData=JSON.parse(localStorage.getItem("loginData"));
if(loginData){
authKey = loginData.token_type+" "+loginData.access_token;
}
this.headers={
"Authorization":authKey
}
},
mounted(){
let id=this.$route.query.id;
let fee=this.$route.query.fee;
if(id){
this.taxId=id;
}
if(fee){
this.taxFee=fee;
}
},
methods:{
openFile(){
this.$refs.file.click();
},
onSuccess(){
that.$vux.toast.show({
text: '上传成功'
})
},

addData(){
this.taxExtraList.push({
amount:"",
category:"",
desc:"",
imageLink:""
})

},










inputChange(e){
this.$vux.loading.show({
text: '上传中，请稍等',
})
let imgInd=e.target.dataset.ind;
let imgfile = e.target.files[0];
let fildata=new FormData();
fildata.append("file",imgfile)
let that=this;
let loginData=JSON.parse(localStorage.getItem("loginData"));
let accessToken=loginData.access_token;
let token=loginData.token_type+" "+loginData.access_token;
lrz(imgfile,{width:300,quality:0.5}).then(function (rst) {
console.log(rst);

let loginData=JSON.parse(localStorage.getItem("loginData"));
let accessToken=loginData.access_token;
let token=loginData.token_type+" "+loginData.access_token;
var xhr = new XMLHttpRequest();
xhr.open('POST', that._Api.upload);
xhr.setRequestHeader("Authorization", token);
xhr.onload = function () {
if (xhr.status === 200) {


that.taxExtraList[imgInd].imageLink=JSON.parse(xhr.response).data;
setTimeout(() => {
that.$vux.loading.hide();
that.$vux.toast.show({
text: '上传成功'
})
}, 500)
} else {
that.$vux.loading.hide();
that.$vux.toast.show({
text: '上传失败,请刷新重试'
})
}
};

xhr.onerror = function () {

};

xhr.upload.onprogress = function (e) {

var percentComplete = ((e.loaded / e.total) || 0) * 100;

};





xhr.send(rst.formData);
/* ==================================================== */

return rst;
})

.catch(function (err) {

$.ajax({
url : that._Api.upload,
type: "POST",
data:fildata,
cache: false,
processData: false,
contentType: false,
beforeSend: function(xhr) {
xhr.setRequestHeader("Authorization", token);
},
success: function(res) {
console.log(res);
that.$vux.loading.hide();
that.$vux.toast.show({
text: '上传成功'
})
},
error:function(res){
that.$vux.loading.hide();
that.$vux.toast.show({
text: '上传失败，请尝试刷新重试'
})
}

});
})

.always(function () {

});

},
delItem(ind){
this.taxExtraList.splice(ind,1);
},
addDedution(){
let _this=this;
let array=this.taxExtraList;
for(let i=0;i<array.length;i++){
if( array[i].category=="" ){
this.$vux.alert.show({
title: '资料不全',
content: "请选择控除类目",
})
return;
}else if(array[i].amount==""){
this.$vux.alert.show({
title: '资料不全',
content: "请填写金额",
})
return;
}else if( array[i].desc=="" ){
this.$vux.alert.show({
title: '资料不全',
content: "请填写资料描述",
})
return;
}else if( array[i].imageLink=="" ){
this.$vux.alert.show({
title: '资料不全',
content: "请上传文件",
})
return;
}else{
console.log(this.taxExtraList);
this.$vux.confirm.show({

title:"确定提交申告吗？",
content:"提交申告将会扣除"+_this.taxFee+"日元手续费",
onCancel () {
},
onConfirm () {
_this.$vux.loading.show({
text: '正在提交',
})
let loginData=JSON.parse(localStorage.getItem("loginData"));
let accessToken=loginData.access_token;
let token=loginData.token_type+" "+loginData.access_token;
$.ajax({
url : _this._Api.report,
type: "POST",
contentType: "application/json;charset=utf-8",
data:JSON.stringify({
"id":_this.taxId,
"taxExtraList":_this.taxExtraList
}),
beforeSend: function(xhr) {
xhr.setRequestHeader("Authorization", token);
},
success: function(res) {

_this.$vux.loading.hide();
_this.$vux.toast.show({
text: '提交成功'
})
setTimeout(() => {
_this.$router.push({
path: '/taxList'
});
}, 500)

},
error:function(res){
_this.$vux.loading.hide();
_this.$vux.toast.show({
text: '发生错误'
})
console.log(res);
}

});
}
})
}
}
},
clearval(e) {
e.target.value = '';
},
}
}



// WEBPACK FOOTER //
// ./src/pages/Deduction.vue